<template>
  <div class="hello">
    <div class="container-fluid">
            <div class="text-center">
                <header>
                        <h1>Free Typing Test</h1>
                    </header>
                <div class="row">
                    <div class="col-3 measurement">
                        <div class="meas_container">
                            <div class="typingIcon">
                                <img src="./assets/speed2.png" width="60">
                            </div>
                            <div id="wpm" class="value">0
                            </div>
                            <div class="title"><span>WPM</span>
                            </div>
                        </div>
                        <div class="change">
                            <span id="wpmChange"></span>
                        </div>
                    </div>
                    <div class="col-3 measurement">
                        <div class="meas_container">
                            <div class="typingIcon">
                                <img src="./assets/cpm.png" width="30">
                            </div>
                            <div id="cpm" class="value">0
                            </div>
                            <div class="title"><span>CPM</span>
                            </div>
                        </div>
                        <div class="change">
                            <span id="cpmChange"></span>
                        </div>
                    </div>
                    <div class="col-3 measurement">
                        <div class="meas_container">
                            <div class="typingIcon">
                                <img src="./assets/accuracy.png" width="50">
                            </div>
                            <div id="accuracy" class="value">0%
                            </div>
                            <div class="title"><span>Accuracy</span>
                            </div>
                        </div>
                        <div class="change">
                            <span id="accuracyChange"></span>
                        </div>
                    </div>
                    <div class="col-3 measurement">
                        <div class="meas_container">
                            <div class="typingIcon">
                                <img src="./assets/stopwatch.png" width="45">
                            </div>
                            <div id="timeLeft" class="value">60
                            </div>
                            <div class="title"><span>Time Left</span>
                            </div>
                        </div>
                    </div>
                </div>
                
<!--                test words-->
                <div id="content" class="text-center"></div>
                
<!--                text input-->
                <div>
                    <input type="text" placeholder="type here" class="text-center" id="input">
                </div>
                
<!--                keyboard-->
                <div class="keyboard"></div>
                
<!--                restart-->
                <div class="restart">
                    <button type="button" class="btn btn-primary btn-lg" onclick="location.reload()">Restart</button>
                </div>
                
<!--                modal-->
                <div class="modal" id="myModal">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title">You finished your test!</h5>
                        <button id="x" type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                          <div class="form-group">
                              <label for="name" class="sr-only">Enter your name: </label>
                              <input type="text" class="form-control" id="name" placeholder="Your full name">
                          </div>
                        
                      </div>
                      <div class="modal-footer">
                          <button id="x1" type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-info" id="download">Download your certificate</button>                    
                      </div>
                    </div>
                  </div>
                </div>
                
            </div>
        </div>
  </div>
</template>

<script>
import dataModule from '@/dataModule';
import wordsModule from '@/wordsModule';
import certificateModule from '@/certificateModule';
export default {
  name: 'HelloWorld',
  data () {
    return {

    }
  },
  mounted(){
    var UIModule = (function(){
    //classes used to select HTML elements
    var DOMElements = {
        //indicators - test control
        timeLeft: document.getElementById('timeLeft'), //HTML element displaying time left
        //test results
        wpm: document.getElementById('wpm'),
        wpmChange: document.getElementById('wpmChange'),
        cpm: document.getElementById('cpm'),
        cpmChange: document.getElementById('cpmChange'),
        accuracy: document.getElementById('accuracy'),
        accuracyChange: document.getElementById('accuracyChange'),
        //user input
        textInput: document.querySelector('#input'),
        nameInput: document.querySelector('.form-group'),
        nameField: document.getElementById('name'),
        //test words
        content:document.getElementById('content'),
        activeWord:'',
        //modal
        modal: document.getElementById('myModal'),
        download: document.getElementById('download')
    };

    // console.log(DOMElements)

    var splitArray = function(string){
        return string.split('');
    };
    
    var addSpace = function(array){
        array.push(' ');
        return array;
    };
    
    var addSpanTags = function(array){
        return array.map(function(currentCharacter){
            return '<span>' + currentCharacter + '</span>';
        });
    };
    
    var addWordSpanTags = function(array){
        array.push('</span>');
        array.unshift('<span>');
        return array;
    };
    
    var joinEachWord = function(array){
        return array.join('');
    };
    
    var userValue;
    var returnCharClass = function(currentCharacter, index){
                return (index < userValue.length)? (currentCharacter == userValue[index]? 'correctCharacter': 'wrongCharacter') : '0'
            };
    
    var updateChange = function(value, changeElement){
        
        //determine the class to add to the change element and html content to insert
        var classToAdd, html;
        [classToAdd, html] = (value >= 0)? ['scoreUp', '+' + value] : ['scoreDown', value];
        
        //add % to the percentage change
        if(changeElement == DOMElements.accuracyChange){
            html += '%';
        }
        
        //update the change element
        changeElement.innerHTML = html;
        
        //style the change element
        changeElement.removeAttribute('class');
        changeElement.className = classToAdd;
        
        //fade element
        fadeElement(changeElement);
    };
    
    var fadeElement = function(element){
        element.style.opacity = 1;
        setTimeout(function(){
            element.style.opacity = 0.9;
        }, 100);
    };
      
        var x = function(event) {
                DOMElements.modal.style.display = "none";
                location.reload();
        } 
        document.getElementById("x").onclick = x; 
        document.getElementById("x1").onclick = x; 
    return {
        
    //get DOM elements
        
        getDOMElements: function(){
            return {
                textInput: DOMElements.textInput,
                download: DOMElements.download
            };
        },
        
    //Indicators - Test Control
    
        updateTimeLeft: function(x){
            DOMElements.timeLeft.innerHTML = x;
        },
        
    //results
        
        updateResults: function(results){
            //update wpm
            DOMElements.wpm.innerHTML = results.wpm;
            //update cpm
            DOMElements.cpm.innerHTML = results.cpm;
            //update accuracy
            DOMElements.accuracy.innerHTML = results.accuracy + '%';
            //update changes
            updateChange(results.wpmChange, DOMElements.wpmChange);
            updateChange(results.cpmChange, DOMElements.cpmChange);
            updateChange(results.accuracyChange, DOMElements.accuracyChange);
        }, 
        
        fillModal: function(wpm){
            var results;
            if(wpm < 40){
                results = {
                    type: 'turtle',
                    image: 'turtle.jpg',
                    level: 'Beginner'
                };
            }else if(wpm < 70){
                results = {
                    type: 'horse',
                    image: 'horse.jpg',
                    level: 'Average'
                };
            }else{
                results = {
                    type: 'puma',
                    image: 'puma.jpg',
                    level: 'Expert'
                };
            }
            
            
            var html = '<div class="result"><p>You type at a speed of %wpm% words per minute!</p></div>';
            
            html = html.replace('%type%', results.type);
            html = html.replace('%wpm%', wpm);
            html = html.replace('%image%', results.image);
            html = html.replace('%alt%', results.type);
            
            //insert html before form-group
            DOMElements.nameInput.insertAdjacentHTML('beforebegin', html);
            
            //store level in download button
            DOMElements.download.setAttribute('level', results.level);
            return results; 
        }, 
        
        showModal: function(){
            DOMElements.modal.style.display = "block";
        },

        hideModal: function(){
            DOMElements.modal.style.display = "none";
        },
        
    //user input
    
        inputFocus: function(){
            DOMElements.textInput.focus();
        }, 
        
        isNameEmpty: function(){
            return DOMElements.nameField.value == '';
        },
        
        flagNameInput: function(){
            DOMElements.nameField.style.borderColor = 'red';
        },   
    
        spacePressed: function(event){
            return event.data == " ";
        }, 
        
        enterPressed: function(lineReturn){
            return DOMElements.textInput.value.includes(lineReturn + ' ');
        }, 
        
        emptyInput: function(){
            DOMElements.textInput.value = "";
        },  
    
        getTypedWord: function(){
            // console.log(DOMElements.textInput.value);
            return DOMElements.textInput.value;
        },
        
    //test words
    
        fillContent: function(array, lineReturn){
            //['word1,', 'word2']
            var content = array.map(splitArray);
//            console.log(content);
            //[['w', 'o', 'r', 'd', '1', ',' ], ['w', 'o', 'r', 'd', '2']]
            content = content.map(addSpace);
//            console.log(content);
            //[['w', 'o', 'r', 'd', '1', ',', ' ' ], ['w', 'o', 'r', 'd', '2', ' ']]
            content = content.map(addSpanTags);
//            console.log(content);
            //[['<span>w</span>', '<span>o</span>', '<span>r</span>', '<span>d</span>', '<span>1</span>', '<span>,</span>', '<span> </span>'], ['<span>w</span>', '<span>o</span>', '<span>r</span>', '<span>d</span>', '<span>1</span>', '<span> </span>']]
            content = content.map(addWordSpanTags);
//            console.log(content);
            //[['<span>', '<span>w</span>', '<span>o</span>', '<span>r</span>', '<span>d</span>', '<span>1</span>', '<span>,</span>', '<span> </span>', '</span>'], ['<span>', '<span>w</span>', '<span>o</span>', '<span>r</span>', '<span>d</span>', '<span>1</span>', '<span> </span>', '</span>']]
            content = content.map(joinEachWord);
//            console.log(content);
            content = content.join('');
//            console.log(content);
            
            //<span><span>w</span><span>o</span><span>r</span><span>d</span><span>1</span><span>,</span><span> </span></span><span><span>w</span><span>o</span><span>r</span><span>d</span><span>2</span><span> </span></span>
            
            
            //replace the line return special code with the HTML entity (line return)
            
            // <span>|</span>
            // <span>&crarr;</span>
//            content = content.replace('<span>|</span>', '<span>&crarr;</span>');
            //split, join
            content = content.split('<span>' + lineReturn + '</span>').join('<span>&crarr;</span>');
            
            
            //fill content
            DOMElements.content.innerHTML = content;
        }, 
        
        formatWord: function(wordObject){
            var activeWord = DOMElements.activeWord;
            
            //highlight current word
            activeWord.className = 'activeWord';
            
            //format individual characters
            var correctValue = wordObject.value.correct;
            userValue = wordObject.value.user;
            
            //correct value 'word1 '
            //user value 'wwrd'
            var classes = Array.prototype.map.call(correctValue, returnCharClass);
            
            //get active word
            var activeWord = DOMElements.activeWord;
            
            //HTML collection
            var characters = activeWord.children;
            
            //add classes to children
            for(var i = 0; i < characters.length; i ++){
                characters[i].removeAttribute('class');
                characters[i].className = classes[i];
            }                        
        }, 
        
        setActiveWord: function(index){
            DOMElements.activeWord = DOMElements.content.children[index];
        }, 
        
        deactivateCurrentWord: function(){
            DOMElements.activeWord.removeAttribute('class');
        }, 
        
        scroll: function(){
            var activeWord = DOMElements.activeWord;
            var top1 = activeWord.offsetTop;
            var top2 = DOMElements.content.offsetTop;
            var diff = top1 - top2;
            //scroll the content of the content box
            DOMElements.content.scrollTop = diff - 40;
        }
    }
})();
var eventsModule = (function(dModule, uModule, cModule, wModule){
    var addEventListeners = function(){
    var keyCode = 0; var rr = "";
      //enter click event
        uModule.getDOMElements().textInput.addEventListener('keydown', function(event){
            // console.log(event);
            //if the test ended, do nothing
            if(dModule.testEnded()){
                return;
            }
            
            //check if the user pressed Enter or space
            keyCode = event.keyCode;
            if(keyCode == 13){
                uModule.getDOMElements().textInput.value += dModule.getLineReturn() + ' ';
                
                //create a new 'input' event
                var inputEvent = new Event('input');
                
                //dispatch it
                uModule.getDOMElements().textInput.dispatchEvent(inputEvent);
            }
            
        });
        
        
        //character typing event listener
        uModule.getDOMElements().textInput.addEventListener('input', function(event){
            
            //if the test ended, do nothing
            if(dModule.testEnded()){
                return;
            }
            
            //if the test has not started yet, start the test and countdown
            if(!dModule.testStarted()){
                
                //start the test: data Module
                dModule.startTest();
                
                //start counter
                
                var b = setInterval(function(){
                //calculate the results: data Module
                    
                    var results = {};
                    //update wpm, wpmChange
                    [results.wpm, results.wpmChange] = dModule.calculateWpm();
                    
                    //update cpm, cpmChange
                    [results.cpm, results.cpmChange] = dModule.calculateCpm();
                    
                    //update accuracy, accuracyChange
                    [results.accuracy, results.accuracyChange] = dModule.calculateAccuracy();
                    
                    //dModule.returnData();
                    
                //update results (UI module)
                    uModule.updateResults(results);
                    
                    
                //check if we have time left
                    if(dModule.timeLeft()){
                        
                        //reduce time by one sec: data Module
                        var timeLeft = dModule.reduceTime();
                        
                        //update time remaining in UI
                        uModule.updateTimeLeft(timeLeft);
                    }else{
                        //end the test: data module
                        clearInterval(b);
                        dModule.endTest();
                    
                        dModule.returnData();
                        
                        //fill modal
                        rr = uModule.fillModal(results.wpm);
                        //show modal
                        uModule.showModal();                        
                    }                                        
                }, 1000);
            }
            
            //get typed word: UI module
            var typedWord = uModule.getTypedWord();
            
            //update current word: data module
            dModule.updateCurrentWord(typedWord);
            
            //format the active word
            var currentWord = dModule.getCurrentWord();
            uModule.formatWord(currentWord);
            
            //check if the user pressed space or enter
            if(keyCode == 32 || keyCode == 13 || currentWord.substring(currentWord.length() - 1)==' '){
                //empty text input
                uModule.emptyInput();
                
                //deactivate current word
                uModule.deactivateCurrentWord();
                
                //move to a new word: data Module
                dModule.moveToNewWord();

                //set active Word: UI Module
                var index = dModule.getCurrentWordIndex();
                uModule.setActiveWord(index);

                //format the active word: UI Module
                var currentWord = dModule.getCurrentWord();
                uModule.formatWord(currentWord);
                
                //scroll word into the middle view
                uModule.scroll();
            }
        });
        
        //click on download button event listener
        uModule.getDOMElements().download.addEventListener('click', function(event){
            if(uModule.isNameEmpty()){
                uModule.flagNameInput();
            }else{
              var certificateData = dModule.getCertificateData();
                certificateData.name = document.getElementById('name').value;
                certificateData.level = rr.level;
                // console.log(certificateData);
                certificateModule.generateCertificate(certificateData);
            }
        });

    };
    
    //scroll active word into middle view on window resize
    window.addEventListener('resize', uModule.scroll);

                    
    return {
        //init function, initializes the test before start
        init: function(duration, textNumber){
            //fill the list of test words: data Module
            var words = wModule.getWords(textNumber);
            dModule.fillListOfTestWords(words.n, words.W);
            
            //fill the list of test words: UI Module
            uModule.fillContent(dModule.getListofTestWords(), dModule.getLineReturn());
            
            //set the total test time: data Module
            dModule.setTestTime(duration);
            
            //update time left: data Module
            dModule.initializeTimeLeft();
            
            //update time left: UI module
            uModule.updateTimeLeft(dModule.getTimeLeft());
            
            //move to a new word: data Module
            dModule.moveToNewWord();
            
            //set active Word: UI Module
            var index = dModule.getCurrentWordIndex();
            uModule.setActiveWord(index);
            
            //format the active word: UI Module
            var currentWord = dModule.getCurrentWord();
            uModule.formatWord(currentWord);
            
            //focus on text input: UI Module
            uModule.inputFocus();
            
            //add avent listeners
            addEventListeners();
        }
    };
             
        
})(dataModule, UIModule, certificateModule, wordsModule);
  var d = new Date();
  eventsModule.init(60,Math.floor(Math.random()*d.getMilliseconds()));
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/*body element*/
#app {
/*    font-family: 'Quattrocento Sans', sans-serif;*/
    background: url("assets/aurora.jpg") no-repeat center center;
    background-attachment: fixed;
    background-size: cover;
    color: white;
}

.meas_container{
    background-color: rgba(236, 34, 202, 0.5);
}

.row{
    font-size: 30px;
}

.title{
    font-size: 14px;
}

.typingIcon{
    height: 50px;
}

#content{
    height: 120px;
    background-color: rgba(255,255,255,0.2);
    margin: 10px auto;
    font-size: 30px;
    overflow: hidden;
    padding: 0 5px;
    line-height: 40px
}

.change{
    height: 25px;
    font-size: 16px;
}

#input{
    background-color: rgba(239, 37, 188, 0.3);
    width: 100%;
    font-size: 30px;
    padding: 10px;
    color: rgb(1, 226, 182)
}

.keyboard{
    min-height: 200px;
    max-height: 300px;
    background: url("assets/keyboard.jpeg") no-repeat center center;
    background-size: contain;
    margin-top: 10px;
}

.restart{
    margin-top: 20px;
    opacity: 0.5
}

.btn-primary{
    background: rgba(236, 34, 202, 0.5)
}

.btn-primary:focus,.btn-primary:active,.btn-primary:hover{
    background: rgba(236, 34, 202, 0.8)
}

.scoreDown, .scoreUp{
    border-radius: 5px;
    padding: 5px;
    font-size: 12px;
}

.scoreDown{
    background: mediumvioletred
}

.scoreUp{
    background: greenyellow;
    color: black
}

.modal{
    color: black;
    overflow: scroll;
}

.activeWord{
    background-color: greenyellow;
    border-radius: 5px;
}

.correctCharacter{
    color: mediumblue;
}

.wrongCharacter{
    color: mediumvioletred;
}

.result{
    font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/HelloWorld.vue